var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfidAccountTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.922 32.7194C33.2583 29.6831 35.3524 25.3056 35.3524 20.4391C35.3524 11.2711 27.9203 3.83905 18.7524 3.83905C9.58443 3.83905 2.15234 11.2711 2.15234 20.4391C2.15234 25.5608 4.47184 30.1407 8.11769 33.1858L8.11891 46.0837C8.11903 47.331 9.46198 48.1168 10.5494 47.5059L18.2973 43.1533C18.7892 42.877 19.3889 42.8744 19.8831 43.1464L27.865 47.5401C28.9523 48.1386 30.2832 47.352 30.2832 46.1109V32.7194H29.922Z",
    fill: "url(#paint0_linear_8143_15510)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8143_15510)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.7605,
    cy: 19.6199,
    r: 18.7605,
    fill: "url(#paint1_linear_8143_15510)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.7605,
    cy: 19.6199,
    r: 18.4558,
    stroke: "url(#paint2_linear_8143_15510)",
    strokeOpacity: 0.8,
    strokeWidth: 0.609478
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8143_15510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5881 12.1587C18.1141 11.2557 19.4185 11.2557 19.9444 12.1587L21.8533 15.4361C22.046 15.7668 22.3688 16.0014 22.7429 16.0824L26.4498 16.8851C27.4711 17.1063 27.8742 18.3469 27.178 19.1261L24.6508 21.9543C24.3958 22.2398 24.2725 22.6193 24.311 23.0001L24.6931 26.7737C24.7984 27.8133 23.7431 28.58 22.7869 28.1586L19.3161 26.6292C18.9658 26.4748 18.5668 26.4748 18.2165 26.6292L14.7457 28.1586C13.7895 28.58 12.7342 27.8133 12.8394 26.7737L13.2215 23.0001C13.2601 22.6193 13.1368 22.2398 12.8817 21.9543L10.3546 19.1261C9.65836 18.3469 10.0615 17.1063 11.0827 16.8851L14.7896 16.0824C15.1637 16.0014 15.4866 15.7668 15.6792 15.4361L17.5881 12.1587Z",
    fill: "url(#paint3_linear_8143_15510)",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8827 12.3302C18.2771 11.653 19.2554 11.653 19.6499 12.3302L21.5588 15.6076C21.7996 16.0211 22.2031 16.3143 22.6708 16.4155L26.3777 17.2183C27.1436 17.3841 27.446 18.3146 26.9238 18.899L24.3967 21.7272C24.0779 22.084 23.9237 22.5584 23.9719 23.0345L24.354 26.808C24.4329 27.5877 23.6415 28.1628 22.9243 27.8467L19.4535 26.3173L19.3161 26.6292L19.4535 26.3173C19.0157 26.1243 18.5169 26.1243 18.079 26.3173L14.6083 27.8467C13.8911 28.1627 13.0996 27.5877 13.1786 26.808L13.5606 23.0345C13.6088 22.5584 13.4547 22.084 13.1359 21.7272L10.6088 18.899C10.0866 18.3146 10.3889 17.3841 11.1549 17.2183L14.8618 16.4155C15.3294 16.3143 15.7329 16.0211 15.9737 15.6076L17.8827 12.3302Z",
    stroke: "white",
    strokeWidth: 0.681702,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8143_15510",
    x: -2.43791,
    y: -1.57854,
    width: 42.3973,
    height: 42.3968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.21896
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8143_15510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8143_15510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8143_15510",
    x: 8.64245,
    y: 11.4814,
    width: 20.2463,
    height: 19.5218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.3634
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.681702
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8143_15510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8143_15510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8143_15510",
    x1: 1.66569,
    y1: 10.9613,
    x2: 35.653,
    y2: 43.9523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE39F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8143_15510",
    x1: 10.1169,
    y1: 3.19462,
    x2: 27.4863,
    y2: 38.3804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE39F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8143_15510",
    x1: 18.7605,
    y1: 0.859375,
    x2: 25.6927,
    y2: 38.3804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8143_15510",
    x1: 18.7663,
    y1: 10.1359,
    x2: 18.7663,
    y2: 29.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidAccountTypeIcon);
export default __webpack_public_path__ + "static/media/bfid-account-type-icon.284b1475d5d38f09a20bf3d6772093f7.svg";
export { ForwardRef as ReactComponent };